/**************************************************
 * Nombre:       Seccion_Escuela.js
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     1 Hr
 **************************************************/
import {Grid} from "@mui/material";
import Tabla_Filtro from "../../Modulo_Tabla_2025/Componentes/Tabla_Filtro";
import {
    CASILLA_ESTADO,
    CASILLA_FECHA_DATOS,
    CASILLA_FUNCION,
    CASILLA_IMG
} from "../../Modulo_Tabla_2025/Componentes/SubComponentes/obtenerCasilla";
import {useObtenerColleccionTabla2025} from "../../Servicios/BD/useObtenerColleccionTabla2025";
import React from "react";
import {useDialogo} from "../../Modulo_Dialogos_2025/Hooks/useDialogo";
import {Loyalty, ManageSearch, Numbers} from "@mui/icons-material";
import {ESTADOSPEDIDOS} from "../../Constantes";
import {useNavigate} from "react-router";
import Dialogo_Escuela from "../Dialogos/Escuelas/Dialogo_Escuela";
import {obtenerNumProgramas} from "../../CodNegocio/Funciones/obtenerNumProgramas";
import Dialogo_Escuela_Beneficios from "../Dialogos/Escuelas/Dialogo_Escuela_Beneficios";
import Dialogo_Escuela_Indicadores from "../Dialogos/Escuelas/Dialogo_Escuela_Indicadores";


const Seccion_Escuela = () => {
    const navigate = useNavigate();
    const {props, setData, setNumeroFilas, cargarNuevamente} = useObtenerColleccionTabla2025({coleccion: 'escuelas'})
    const {Dialogo, abrir} = useDialogo({
        Componente: Dialogo_Escuela,
        titulo: 'Detalles la Escuela',
        realizado: cargarNuevamente
    })
    const {Dialogo: DialogoBeneficios, abrir: abrirBeneficios} = useDialogo({
        Componente: Dialogo_Escuela_Beneficios,
        titulo: 'Beneficios de pertenencer',
        realizado: cargarNuevamente
    })
    const {Dialogo: DialogoIndicadores, abrir: abrirIndicadores} = useDialogo({
        Componente: Dialogo_Escuela_Indicadores,
        titulo: 'Indicadores',
        realizado: cargarNuevamente
    })

    const click = (id, data) => {
        switch (id) {
            case 'detalles':
                abrir(data)
                break;
            case 'beneficios':
                abrirBeneficios(data)
                break;
            case 'indicadores':
                abrirIndicadores(data)
                break;
            default :
                abrir(data)
        }
    }


    return (

        <Grid container size={{xs: 12, sm: 12, md: 12}} justifyContent={'center'}>

            <Grid
                container
                justifyContent={'flex-start'}
                alignItems={'flex-start'}
                size={{xs: 12, sm: 12, md: 12}}
                sx={{marginTop: 2.5, maxWidth: '1200px'}}
                spacing={3}
            >

                <Dialogo/>

                <DialogoBeneficios/>

                <DialogoIndicadores/>

                <Grid container size={{xs: 12, sm: 12, md: 12}}>
                    <Tabla_Filtro
                        nombre={'Lista de Escuelas de Apendizaje'}
                        descripcion={`${props.numeroFilas} en base de datos`}
                        filtros={filtros}
                        datosCabecera={datosCabecera}
                        {...props}
                        clickAgregar={abrir}
                        botonesData={botonesData}
                        clickData={click}
                        // funcionBuscar={funcionBuscar}
                        //  botones={[]}
                        //ComponenteInferior={ExportadorDatos}

                    />
                </Grid>

            </Grid>

        </Grid>
    )

}
export default Seccion_Escuela

const filtros = [
    {
        nombre: 'Nombre',
        direccion: 'asc',
        propiedad: 'nombre'
    },
    {
        nombre: 'Mas Reciente',
        direccion: 'desc',
        propiedad: 'fecha'
    },
]


const datosCabecera = [
    {
        nombre: 'Img',
        direccion: 'left',
        propiedad: 'img',
        size: 52,
        tipo: CASILLA_IMG
    },
    {
        nombre: 'Nombre',
        direccion: 'left',
        propiedades: ['nombre'],
        fecha: 'fecha',
        tipo: CASILLA_FECHA_DATOS
    },
    {
        nombre: 'Num Programas',
        direccion: 'left',
        propiedad: 'profesional',
        fecha: 'fechaEspacio',
        funcion: obtenerNumProgramas,
        tipo: CASILLA_FUNCION
    },
    {
        nombre: 'Estado',
        direccion: 'right',
        propiedad: 'estado',
        tipo: CASILLA_ESTADO,
        estados: ESTADOSPEDIDOS
    },

]

const botonesData = [
    {
        nombre: 'Detalles',
        id: 'detalles',
        icono: ManageSearch
    },
    {
        nombre: 'Beneficios',
        id: 'beneficios',
        icono: Loyalty
    },
    {
        nombre: 'Indicadores',
        id: 'indicadores',
        icono: Numbers
    }
]

